export interface CompositionItem {
  name: string;
  amount: string;
}

export interface Product {
  id: number;
  name: string;
  category: string;
  benefit: string;
  sizes: string[];
  image: string;
  badge?: string;
  description: string;
  compositionNote: string;
  composition: CompositionItem[];
  keyBenefits: string[];
  indications: string[];
  dosage: string;
  targetAnimals: string[];
  fullSizeImage: string;
  mechanismOfAction?: string;
  whyDifferent?: string;
  perfectFor?: string[];
}

export const products: Product[] = [
  {
    id: 1,
    name: 'Udder Max Liquid',
    category: 'Udder Development',
    benefit: 'Advanced udder growth & milk enhancement formula for dairy animals',
    sizes: ['1000ml', '5 Liters'],
    badge: 'Bestseller',
    image: 'https://storage.readdy-site.link/project_files/be4287be-1b15-4a9d-9900-25ef163f62d9/5a72c2ef-eb2c-4a22-9bf5-010b514054d7_i_want_to_202604240216.jpeg?v=c3b1c70a7884c7ba2e56d7de727e73d8',
    fullSizeImage: 'https://storage.readdy-site.link/project_files/be4287be-1b15-4a9d-9900-25ef163f62d9/5a72c2ef-eb2c-4a22-9bf5-010b514054d7_i_want_to_202604240216.jpeg?v=c3b1c70a7884c7ba2e56d7de727e73d8',
    description: 'Udder Max Liquid is a premium scientifically balanced formula designed to promote udder growth, enhance milk production and improve overall dairy performance. It is a new advanced formula for animals (female) that promotes udder development and improves overall milk production and body development.',
    compositionNote: 'Each 1000ml contains:',
    composition: [
      { name: 'Vitamin H (USP)', amount: '20mcg' },
      { name: 'Vitamin E (USP)', amount: '50mg' },
      { name: 'Vitamin A (USP)', amount: '20000IU' },
      { name: 'Vitamin D3 (USP)', amount: '10000IU' },
      { name: 'Vitamin B12 (USP)', amount: '40mg' },
    ],
    keyBenefits: [
      'Promotes rapid udder growth & development',
      'Helps increase milk production capacity',
      'Strengthens mammary gland structure',
      'Improves blood circulation in udder',
      'Ideal for small or underdeveloped udder',
      'Enhances overall farm profitability',
    ],
    indications: [
      'Small or underdeveloped udder',
      'Low milk production',
      'Pregnant animals (before calving)',
      'Weak mammary glands',
    ],
    dosage: 'Cattle & Buffaloes: 50ml daily. Mix in water or feed. Note: Start 60 days before calving and continue after calving for best results.',
    targetAnimals: ['Dairy Cattle', 'Buffalo'],
  },
  {
    id: 2,
    name: 'Calpho Max-D Liquid',
    category: 'Milk Booster',
    benefit: 'Premium milk booster with calcium, phosphorus & vitamins for dairy animals',
    sizes: ['500ml', '1 Liter', '5 Liters'],
    image: 'https://static.readdy.ai/image/a84fce21c15147349888dd3eeb9b8000/8e26c43547a3e8c8982286d7777202ed.jpeg',
    fullSizeImage: 'https://static.readdy.ai/image/a84fce21c15147349888dd3eeb9b8000/8e26c43547a3e8c8982286d7777202ed.jpeg',
    description: 'Calpho Max-D Liquid is a high-quality calcium supplement enriched with Vitamin D3, phosphorus, and essential minerals. It helps increase milk production, strengthen bones, and improve overall animal performance. Its fast-absorbing formula ensures better calcium utilization in the body.',
    compositionNote: 'Each 100ml contains:',
    composition: [
      { name: 'Tricalcium Phosphate (USP)', amount: '2466.5mg' },
      { name: 'Vitamin A (USP)', amount: '13000IU' },
      { name: 'Vitamin D3 (USP)', amount: '400IU' },
      { name: 'Vitamin B1 (USP)', amount: '100mg' },
      { name: 'Vitamin E (USP)', amount: '100mg' },
    ],
    keyBenefits: [
      'Increases milk production',
      'Prevents milk fever (calcium deficiency)',
      'Strengthens bones & teeth',
      'Improves udder development',
      'Supports fertility & reproduction',
      'Helps in post-calving recovery',
    ],
    indications: [
      'Low milk production',
      'Calcium deficiency',
      'Weak animals',
      'Pregnant & lactating animals',
      'Post-calving weakness',
    ],
    dosage: 'Cows & Buffaloes: 100–150ml daily. High yielders: 150–200ml daily. Or as directed by veterinarian.',
    targetAnimals: ['Dairy Cattle', 'Buffalo', 'Pregnant Animals', 'Lactating Animals'],
  },
  {
    id: 3,
    name: 'Beef Plus Gold Liquid',
    category: 'Growth Promoter',
    benefit: 'Powerful advanced growth promoter for fast weight gain, muscle development & improved livestock performance',
    sizes: ['500ml', '1 Liter', '3 Liters', '5 Liters', '10 Liters', '20 Liters'],
    badge: 'Top Rated',
    image: 'https://storage.readdy-site.link/project_files/be4287be-1b15-4a9d-9900-25ef163f62d9/e319d4dc-22e9-4905-85a5-845e4215db9b_i_want_to_202604240221.jpeg?v=553e861b7523e605861cf2a7c3f0523d',
    fullSizeImage: 'https://storage.readdy-site.link/project_files/be4287be-1b15-4a9d-9900-25ef163f62d9/e319d4dc-22e9-4905-85a5-845e4215db9b_i_want_to_202604240221.jpeg?v=553e861b7523e605861cf2a7c3f0523d',
    description: 'Beef Plus Gold Liquid is a powerful and advanced growth promoter formula specially developed for cattle, buffalo, calves, and livestock. It promotes fast body growth and weight gain while improving meat quality and overall animal performance.',
    compositionNote: 'Each 1000ml contains:',
    composition: [
      { name: 'Vitamin A (USP)', amount: '2,350,000IU' },
      { name: 'Cholecalciferol (USP)', amount: '450,000IU' },
      { name: 'Vitamin E (USP)', amount: '2350IU' },
      { name: 'Thiamine HCL (USP)', amount: '1000mg' },
      { name: 'Riboflavin (USP)', amount: '240mg' },
      { name: 'Pyridoxine HCL (USP)', amount: '1700mg' },
      { name: 'Cyanocoblamin (USP)', amount: '0.9mg' },
      { name: 'Phytomenadione (USP)', amount: '280mg' },
      { name: 'Ascorbic Acid (USP)', amount: '30mg' },
      { name: 'Folic Acid (USP)', amount: '250mg' },
      { name: 'Pantothenic Acid (USP)', amount: '9000mg' },
      { name: 'Methionine Acid (USP)', amount: '5000mg' },
      { name: 'Lysine HCL (USP)', amount: '3720mg' },
      { name: 'Threonine (USP)', amount: '2500mg' },
    ],
    keyBenefits: [
      'Fast body growth & weight gain',
      'Improves meat quality and muscle development',
      'Enhances feed conversion ratio (FCR)',
      'Increases energy, strength & immunity',
      'Better overall performance of animals',
      'Improves digestion and nutrient absorption',
    ],
    indications: [
      'Slow growth & low weight gain',
      'Poor feed conversion',
      'Muscle weakness & low immunity',
      'Pre-market fattening period',
    ],
    dosage: 'Cattle: 100ml daily | Buffalo/Calf: 50ml daily | Goat/Sheep: 25ml daily | Small animals: 15ml daily. Mix in water or feed. Note: Using for 90 days can increase weight from 75kg to 120kg.',
    targetAnimals: ['Cattle', 'Buffalo', 'Calves', 'Goat', 'Sheep', 'Livestock'],
  },
  {
    id: 4,
    name: 'Fibros Hum Finish',
    category: 'Mastitis Management',
    benefit: 'Advanced herbal support for mastitis control, udder health & milk quality restoration',
    sizes: ['Liquid 1000ml', 'Tablets 200'],
    image: 'https://static.readdy.ai/image/a84fce21c15147349888dd3eeb9b8000/3445b5eb8b0b00227b775ae91c189b76.jpeg',
    fullSizeImage: 'https://static.readdy.ai/image/a84fce21c15147349888dd3eeb9b8000/3445b5eb8b0b00227b775ae91c189b76.jpeg',
    description: 'Fibros Hum Finish Liquid is a specialized herbal formulation designed to support the treatment and recovery of mastitis in dairy animals. It helps reduce inflammation, improve udder health, and restore milk production while supporting the animal\'s immune system.',
    compositionNote: 'Each 1000ml contains:',
    composition: [
      { name: 'Ocimum Sanctum Ext. (MS)', amount: '4000mg' },
      { name: 'Azadirachta Indica Ext. (MS)', amount: '8000mg' },
      { name: 'Curcuma Longum Ext. (MS)', amount: '4000mg' },
      { name: 'Nigella Sativa Ext. (MS)', amount: '2000mg' },
      { name: 'Zingibar Officinale Ext. (MS)', amount: '2000mg' },
      { name: 'Piper Longum Ext. (MS)', amount: '2000mg' },
    ],
    keyBenefits: [
      'Helps control mastitis infection',
      'Reduces udder swelling and inflammation',
      'Improves milk quality and yield',
      'Supports faster recovery of udder tissue',
      'Enhances natural immunity',
      'Helps prevent recurrence',
    ],
    indications: [
      'Clinical & subclinical mastitis',
      'Udder swelling and hardness',
      'Flakes/clots in milk',
      'Reduced milk production',
      'Post-mastitis recovery',
    ],
    dosage: 'Liquid: 25ml morning & evening. Tablets: 5 morning & evening. Continue for full recovery course as advised.',
    targetAnimals: ['Dairy Cattle', 'Buffalo', 'Dairy Animals'],
  },
  {
    id: 5,
    name: 'Livo Lum Liver Gold',
    category: 'Liver Tonic',
    benefit: 'Powerful liver stimulant & detoxifier to improve liver function, digestion & overall animal performance',
    sizes: ['500ml', '1 Liter', '5 Liter'],
    badge: 'New',
    image: 'https://static.readdy.ai/image/a84fce21c15147349888dd3eeb9b8000/f402c777a0e9c1687836498e371ff9f4.jpeg',
    fullSizeImage: 'https://static.readdy.ai/image/a84fce21c15147349888dd3eeb9b8000/f402c777a0e9c1687836498e371ff9f4.jpeg',
    description: 'Livo Lum Liquid is a powerful liver stimulant and detoxifier specially formulated to improve liver function, enhance digestion and boost overall animal performance. It supports better metabolism and helps animals recover from stress, toxins, and diseases.',
    compositionNote: 'Each 1000ml contains:',
    composition: [
      { name: 'Sorbitol (USP)', amount: '20,000mg' },
      { name: 'Milk Thistle Extract (MS)', amount: '10,000mg' },
      { name: 'Lysine (USP)', amount: '2000mg' },
      { name: 'Choline Chloride (USP)', amount: '5000mg' },
      { name: 'Camitin (USP)', amount: '2500mg' },
      { name: 'Malic Acid (USP)', amount: '500mg' },
      { name: 'Methionine (USP)', amount: '500mg' },
      { name: 'Betaine (USP)', amount: '10,000mg' },
    ],
    keyBenefits: [
      'Improves liver function and detoxification',
      'Enhances appetite and feed intake',
      'Promotes better digestion and nutrient absorption',
      'Increases milk production in dairy animals',
      'Helps in recovery from diseases and drug toxicity',
      'Supports growth and overall health',
    ],
    indications: [
      'Liver weakness & poor detoxification',
      'Loss of appetite & poor feed intake',
      'Low milk production',
      'Recovery from disease or drug toxicity',
      'Slow growth & general weakness',
    ],
    dosage: 'Cattle/Buffalo: 50–100ml daily | Goat/Sheep: 25–50ml daily | Poultry: 1ml per 2L water for 4–5 days.',
    targetAnimals: ['Cattle', 'Buffalo', 'Goat', 'Sheep', 'Poultry'],
  },
  {
    id: 6,
    name: 'C-Vit. Minerals Liquid',
    category: 'Vitamin Supplement',
    benefit: 'Fast-absorbing Vitamin C & minerals supplement to boost immunity, milk production & stress resistance',
    sizes: ['1000ml', '5 Liters'],
    badge: 'Premium',
    image: 'https://static.readdy.ai/image/a84fce21c15147349888dd3eeb9b8000/3ed9afbde833b9b90d1eab120c5ad10b.jpeg',
    fullSizeImage: 'https://static.readdy.ai/image/a84fce21c15147349888dd3eeb9b8000/3ed9afbde833b9b90d1eab120c5ad10b.jpeg',
    description: 'C-Vit. Minerals Liquid is a fast-absorbing oral supplement containing Vitamin C with essential minerals, specially formulated to improve immunity, milk production and stress resistance in animals. Eliminates effects of heat stress and improves appetite and strength.',
    compositionNote: 'Each 1ml contains:',
    composition: [
      { name: 'Vitamin A (USP)', amount: '25000IU' },
      { name: 'Cholecalciferol (USP)', amount: '12000IU' },
      { name: 'Vitamin E (USP)', amount: '50mg' },
      { name: 'Vitamin K (USP)', amount: '1mg' },
      { name: 'Biotin (USP)', amount: '10mg' },
      { name: 'Ascorbic Acid (USP)', amount: '100mg' },
    ],
    keyBenefits: [
      'Boosts immunity & disease resistance',
      'Reduces heat stress & environmental stress',
      'Improves milk yield & milk quality',
      'Enhances appetite & digestion',
      'Strengthens bones & body condition',
      'Helps in quick recovery after illness',
    ],
    indications: [
      'Heat stress (summer season)',
      'Low milk production',
      'Weakness & mineral deficiency',
      'After disease / vaccination',
      'Transportation stress',
    ],
    dosage: 'Cattle/Buffalo: 50ml daily. Mix in water or feed. Use consistently for best results.',
    targetAnimals: ['Dairy Cattle', 'Buffalo', 'Livestock'],
  },
  {
    id: 7,
    name: 'UTRI HEAL Liquid',
    category: 'Veterinary Medicine / Fertility Support',
    benefit: 'Premium uterine health and fertility support formula for dairy animals, improving reproductive performance',
    sizes: ['1000ml', '5 Liters'],
    badge: 'New',
    image: 'https://storage.readdy-site.link/project_files/be4287be-1b15-4a9d-9900-25ef163f62d9/aa040c89-ed3e-4383-aa5b-b04f82ab07a3_ChatGPT-Image-May-4-2026-10_04_19-AM.png?v=188f682630e3d64d98feeaf11130a73d',
    fullSizeImage: 'https://storage.readdy-site.link/project_files/be4287be-1b15-4a9d-9900-25ef163f62d9/aa040c89-ed3e-4383-aa5b-b04f82ab07a3_ChatGPT-Image-May-4-2026-10_04_19-AM.png?v=188f682630e3d64d98feeaf11130a73d',
    description: 'UTRI HEAL Liquid is a premium uterine health and fertility support formula for dairy animals, designed to improve reproductive performance in cows and buffaloes.',
    compositionNote: 'Each 1000ml contains:',
    composition: [
      { name: 'Vaccinium Macrocarpon Extract (MS)', amount: '200mg' },
      { name: 'Vitamin E (USP)', amount: '2mg' },
      { name: 'Vitamin C (USP)', amount: '30mg' },
    ],
    keyBenefits: [
      'Supports leucorrhea (vaginal discharge) cases',
      'Reduces repeat breeding issues',
      'Promotes uterine cleansing after calving',
      'Improves fertility and conception rate',
      'Supports recovery from uterine infections',
      'Helps regulate normal heat cycle',
    ],
    indications: [
      'White discharge (Leucorrhea)',
      'Repeat breeding cases',
      'Post-calving uterine weakness',
      'Poor conception rate',
      'Irregular heat cycles',
    ],
    dosage: 'Cattle & Buffaloes: 100ml daily. Mix in water or feed. Administer consistently for best fertility results.',
    targetAnimals: ['Dairy Cattle', 'Buffalo', 'Cows', 'Dairy Animals'],
    mechanismOfAction: 'Enhances uterine tone, clears abnormal discharges, and restores reproductive tract balance for improved fertility.',
  },
  {
    id: 8,
    name: 'BEEF SOL Powder / Granules',
    category: 'Feed Additive / Fattening Supplement',
    benefit: 'Next-generation fattening supplement with advanced rumen bypass technology for rapid growth and superior carcass quality',
    sizes: ['100 gm', '500 gm'],
    badge: 'Premium',
    image: 'https://storage.readdy-site.link/project_files/be4287be-1b15-4a9d-9900-25ef163f62d9/21109563-4e95-4486-b26b-34b6693869dc_ChatGPT-Image-May-4-2026-10_11_53-AM.png?v=2cc1a32b84fa9983292914fd36f5056e',
    fullSizeImage: 'https://storage.readdy-site.link/project_files/be4287be-1b15-4a9d-9900-25ef163f62d9/21109563-4e95-4486-b26b-34b6693869dc_ChatGPT-Image-May-4-2026-10_11_53-AM.png?v=2cc1a32b84fa9983292914fd36f5056e',
    description: 'BEEF SOL Powder / Granules is a next-generation fattening supplement developed with advanced rumen bypass technology. It combines high-energy bypass fat, protected protein, and live yeast culture to deliver rapid growth, improved feed efficiency, and superior carcass quality.',
    compositionNote: 'Each 100gm contains:',
    composition: [
      { name: 'Vitamin A (USP)', amount: '2,350,000 IU' },
      { name: 'Vitamin D3 (USP)', amount: '450,000 IU' },
      { name: 'Vitamin E (USP)', amount: '2350 IU' },
      { name: 'Thiamine HCL (USP)', amount: '1000 mg' },
      { name: 'Riboflavin (USP)', amount: '240 mg' },
      { name: 'Pyridoxine HCL (USP)', amount: '1700 mg' },
      { name: 'Cyanocobalamin (USP)', amount: '0.9 mg' },
      { name: 'Phytonadione Acid (USP)', amount: '280 mg' },
      { name: 'Ascorbic Acid (USP)', amount: '30 mg' },
      { name: 'Folic Acid (USP)', amount: '250 mg' },
      { name: 'Pantothenic Acid (USP)', amount: '9000 mg' },
      { name: 'Methionine (USP)', amount: '5000 mg' },
      { name: 'Lysine HCL (USP)', amount: '3720 mg' },
      { name: 'Threonine (USP)', amount: '2500 mg' },
    ],
    keyBenefits: [
      'Rapid weight gain with visible results',
      'Increased feed intake and faster growth',
      'Superior feed conversion ratio (FCR)',
      'Strong muscle development and better meat quality',
      'High energy supply for fattening',
      'Improved digestion and rumen health',
      'Stronger immunity and stress resistance',
    ],
    indications: [
      'Slow growth and low weight gain',
      'Poor feed conversion',
      'Weak or low body condition animals',
      'Pre-sale weight gain programs',
      'Heat stress recovery',
    ],
    dosage: 'Fattening animals: 30–50 gm per day. Calves: 20–30 gm per day. Mix thoroughly in feed.',
    targetAnimals: ['Cattle', 'Buffalo', 'Calves', 'Livestock'],
    whyDifferent: 'Unlike ordinary supplements, BEEF SOL works beyond the rumen, ensuring direct nutrient absorption where it matters most, resulting in faster, visible, and more profitable results.',
    perfectFor: [
      'Beef fattening farms',
      'Dairy farms',
      'Weak or low body condition animals',
      'Pre-sale weight gain programs',
      'Heat stress recovery',
    ],
  },
];

export const categories = [
  {
    id: 1,
    name: 'Growth Promoters',
    count: 1,
    icon: 'ri-arrow-up-line',
    image: 'https://readdy.ai/api/search-image?query=healthy%20strong%20cattle%20livestock%20bull%20dramatic%20cinematic%20golden%20hour%20photography%20powerful%20animal%20standing%20in%20open%20farm%20field%20green%20grass%20sky%20background&width=600&height=400&seq=cat1&orientation=landscape',
  },
  {
    id: 2,
    name: 'Milk Boosters',
    count: 2,
    icon: 'ri-leaf-line',
    image: 'https://readdy.ai/api/search-image?query=dairy%20cow%20milk%20production%20modern%20farm%20clean%20professional%20bright%20lighting%20agriculture%20premium%20quality%20livestock%20health&width=600&height=400&seq=cat2&orientation=landscape',
  },
  {
    id: 3,
    name: 'Veterinary Medicines',
    count: 4,
    icon: 'ri-medicine-bottle-line',
    image: 'https://readdy.ai/api/search-image?query=veterinary%20pharmaceutical%20medicine%20bottles%20vials%20modern%20laboratory%20clean%20professional%20bright%20lighting%20science%20health%20animal%20medicine%20precision%20quality&width=600&height=400&seq=cat3&orientation=landscape',
  },
];

export function getProductById(id: number): Product | undefined {
  return products.find((p) => p.id === id);
}

export function getRelatedProducts(currentId: number, category: string): Product[] {
  return products
    .filter((p) => p.id !== currentId && p.category === category)
    .slice(0, 3);
}
